import { getChainGroups } from '../constants/groups';
import { ChainGroupID } from '../types';

export const getGroupById = (id: ChainGroupID) =>
  getChainGroups().find(group => group.id === id);
